/**
 * True when a mécanicien value represents an assignment (not a clear).
 */
export function mecanicienEstChoisi(mecanicien: unknown): boolean {
    if (mecanicien == null || mecanicien === '') {
        return false;
    }
    if (typeof mecanicien === 'number') {
        return mecanicien > 0;
    }
    if (typeof mecanicien === 'object' && 'employeId' in mecanicien) {
        const id = (mecanicien as { employeId?: number | null }).employeId;
        return id != null && id > 0;
    }
    return true;
}

/**
 * Marks an étape complete when a mécanicien is assigned.
 * Clearing the mécanicien does not revert completion.
 */
export function marquerEtapeFaiteSiMecanicienChoisi(
    etape: { indComplete?: boolean } | null | undefined,
    mecanicien: unknown
): void {
    if (!etape) {
        return;
    }
    if (mecanicienEstChoisi(mecanicien)) {
        etape.indComplete = true;
    }
}

/**
 * Returns the Fait? flag after a « Fait par » selection in the add-étapes dialog.
 */
export function indCompleteApresChoixMecanicien(
    mecanicien: unknown,
    indCompleteActuel: boolean
): boolean {
    return mecanicienEstChoisi(mecanicien) ? true : indCompleteActuel;
}
